import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isValidElementType } from 'react-is';
import { Route, Redirect } from 'react-router';

export default class AuthenticatedRoute extends Component {
  static propTypes = {
    requiredRole: PropTypes.string.isRequired,
    onlyVerified: PropTypes.bool,
    component: (props, propName) => {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    signInUrl: PropTypes.string,
    notVerifiedUrl: PropTypes.string,
    noRoleUrl: PropTypes.string,
    isTokenExist: PropTypes.bool,
    userRoles: PropTypes.array,
    isAuthorizing: PropTypes.bool,
  };

  static defaultProps = {
    signInUrl: '/sign-in',
    notVerifiedUrl: '/not-verified',
    noRoleUrl: '/403',
  };

  render() {
    const {
      component: Component,
      isTokenExist, userRoles, isAuthorizing, isUserInfoRequesting, isVerified,
      noRoleUrl, notVerifiedUrl, signInUrl,
      requiredRole, onlyVerified, ...rest
    } = this.props;

    return (
      <Route {...rest} render={
        props => {
          if (isAuthorizing) {
            return null;
          }
          if (!isTokenExist) {
            return (
              <Redirect to={{
                pathname: signInUrl,
                state: { from: props.location },
              }} />
            );
          }
          if (onlyVerified) {
            if (isUserInfoRequesting) {
              return null;
            }
            if (!isVerified) {
              return (
                <Redirect to={{
                  pathname: notVerifiedUrl,
                  state: { from: props.location },
                }} />
              );
            }
          }

          if (requiredRole && userRoles?.indexOf?.(requiredRole) === -1) {
            ///No required role
            return (
              <Redirect to={{
                pathname: noRoleUrl,
                state: { from: props.location },
              }} />
            );
          }

          return <Component {...props} />;
        }
      } />
    );
  }
}
